export const productColor = {
  none: '#4e5cec',
  data: '#4e5cec',
  measure: '#54cad9',
  engage: '#edcb3b',
  influence: '#b674d3',
  admin: '#d65858',
}
